import { EmissionScope } from '@enmon/commons/lib/shared/emissions';

export const EMISSION_SCOPE_TRANSLATED = {
  [EmissionScope.One]: '1',
  [EmissionScope.Two]: '2',
  [EmissionScope.Three]: '3',
};
